import React, { useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { loadingToggleAction, loginAction } from '../../store/actions/AuthActions';
import { Eye, EyeOff, User, Lock } from 'lucide-react';

//
import logo from '../../images/medsky_logo.png';

function Login(props) {
  const [userName, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  let errorsObj = { userName: '', password: '' };
  const [errors, setErrors] = useState(errorsObj);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  function onLogin(e) {
    e.preventDefault();
    let error = false;
    const errorObj = { ...errorsObj };
    if (userName === '') {
      errorObj.userName = 'User Name is Required';
      error = true;
    }
    if (password === '') {
      errorObj.password = 'Password is Required';
      error = true;
    }
    setErrors(errorObj);
    if (error) {
      return;
    }
    dispatch(loadingToggleAction(true));
    dispatch(loginAction(userName, password, navigate));
  }

  return (
    <div className="login-form-bx">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-6 col-md-7 box-skew d-flex">
            <div className="authincation-content">
              <Link to="#" className="login-logo">
                <img src={logo} alt="" className="logo-icon me-2" />
                <span className="d-none d-lg-inline fs-3 fw-bold text-dark ">
                  Medsky <span className="text-primary">AMC</span>
                </span>
              </Link>
              <div className="mb-4">
                <h3 className="mb-1 font-w600">Welcome to Medsky</h3>
                <p className="">Sign in by entering information below</p>
              </div>
              {props.errorMessage && (
                <div className="bg-red-300 text-red-900 border border-red-900 p-1 my-2">
                  {props.errorMessage}
                </div>
              )}
              {props.successMessage && (
                <div className="bg-green-300 text-green-900 border border-green-900 p-1 my-2">
                  {props.successMessage}
                </div>
              )}
              <form onSubmit={onLogin}>
                <div className="form-group mb-4">
                  <label className="mb-2 text-dark font-w600">User Name</label>
                  <div
                    className="input-group align-items-center"
                    style={{
                      borderRadius: '12px',
                      border: '1px solid #e2e8f0',
                      overflow: 'hidden',
                      transition: 'all 0.3s',
                      boxShadow: '0 4px 6px rgba(0,0,0,0.02)',
                      backgroundColor: '#fff'
                    }}
                  >
                    <span className="input-group-text border-0 bg-transparent px-3">
                      <User size={20} color="#64748b" />
                    </span>
                    <input
                      type="text"
                      className="form-control border-0 shadow-none px-1"
                      placeholder="e.g. SUPER ADMIN"
                      value={userName}
                      onChange={(e) => setEmail(e.target.value)}
                      disabled={props.showLoading}
                      style={{ height: '52px', fontSize: '15px' }}
                    />
                  </div>
                  {errors.userName && (
                    <div className="text-danger fs-12 mt-1">{errors.userName}</div>
                  )}
                </div>
                <div className="form-group mb-4">
                  <label className="mb-2 text-dark font-w600">Password</label>
                  <div
                    className="input-group align-items-center"
                    style={{
                      borderRadius: '12px',
                      border: '1px solid #e2e8f0',
                      overflow: 'hidden',
                      transition: 'all 0.3s',
                      boxShadow: '0 4px 6px rgba(0,0,0,0.02)',
                      backgroundColor: '#fff'
                    }}
                  >
                    <span className="input-group-text border-0 bg-transparent px-3">
                      <Lock size={20} color="#64748b" />
                    </span>
                    <input
                      type={showPassword ? 'text' : 'password'}
                      className="form-control border-0 shadow-none px-1"
                      placeholder="Enter your password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      disabled={props.showLoading}
                      style={{ height: '52px', fontSize: '15px' }}
                    />
                    <span
                      className="input-group-text border-0 bg-transparent px-3"
                      onClick={() => setShowPassword(!showPassword)}
                      style={{ cursor: 'pointer' }}
                    >
                      {showPassword ? (
                        <EyeOff size={20} color="#64748b" />
                      ) : (
                        <Eye size={20} color="#64748b" />
                      )}
                    </span>
                  </div>
                  {errors.password && (
                    <div className="text-danger fs-12 mt-1">{errors.password}</div>
                  )}
                </div>
                <div className="text-center mt-5">
                  {props.showLoading ? (
                    <div id="preloader" style={{ padding: '10px' }}>
                      <div className="sk-three-bounce">
                        <div className="sk-child sk-bounce1"></div>
                        <div className="sk-child sk-bounce2"></div>
                        <div className="sk-child sk-bounce3"></div>
                      </div>
                    </div>
                  ) : (
                    <button
                      type="submit"
                      className="btn btn-primary btn-block"
                      style={{
                        height: '52px',
                        borderRadius: '12px',
                        fontSize: '16px',
                        fontWeight: '600',
                        letterSpacing: '0.5px',
                        transition: 'all 0.3s ease'
                      }}
                    >
                      Log In
                    </button>
                  )}
                </div>
              </form>
            </div>
          </div>
          <div className="col-lg-6 col-md-5 d-flex box-skew1"></div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    errorMessage: state.auth.errorMessage,
    successMessage: state.auth.successMessage,
    showLoading: state.auth.showLoading
  };
};
export default connect(mapStateToProps)(Login);
